"use client"

import { create } from "zustand"
import { setCookie, getCookie } from "cookies-next"

interface LocaleState {
  locale: "en" | "am"
  setLocale: (newLocale: "en" | "am") => void
}

const useLocaleStore = create<LocaleState>((set) => {
  // Try to read cookie value once during initialization
  let initialLocale: "en" | "am" = "en"
  const cookieLocale = getCookie("locale")
  if (cookieLocale === "en" || cookieLocale === "am") {
    initialLocale = cookieLocale
  }

  return {
    locale: initialLocale,
    setLocale: (newLocale: "en" | "am") => {
      set(() => ({ locale: newLocale }))
      setCookie("locale", newLocale, { path: "/" })
    },
  }
})

export default useLocaleStore
